import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useExperienceWizard } from 'core/contexts/experienceWizard';
import { PayNow } from '@utriper/core';
import { Form } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { Box, Grid2 } from '@mui/material';
import Title from 'modules/Pricing/components/Title';
import ActionButtons from 'modules/Pricing/PriceGroupWizard/components/ActionButtons';
import PoliciesFormFields from 'modules/Experience/components/PoliciesFormFields';

const PoliciesForm = () => {
    const { t } = useTranslation();
    const translate = (key) => t(`experience_form.${key}`);
    const { stepData, handleBack, handleNext, updateStepData, STEP_KEYS } = useExperienceWizard();
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = (values) => {
        updateStepData(STEP_KEYS.STEP_5, values);
        handleNext();
    };

    const validateForm = (values) => {
        const errors = {};

        // Validate Pay Now
        if (Number.isFinite(values?.payNow) && !Number.isInteger(values?.payNowType)) {
            errors.payNowType = translate('errors.missing_pay_now_type');
        }

        if (PayNow.isTypePercentage(values?.payNowType) && values?.payNow > 100) {
            errors.payNow = translate('errors.invalid_percentage');
        }

        if (!Number.isFinite(values?.payNow) && Number.isInteger(values?.payNowType)) {
            errors.payNow = translate('errors.missing_pay_now');
        }

        // Validate Policies
        if (values?.refundable && (!values?.cancelPolicies || values?.cancelPolicies?.length <= 0)) {
            errors.cancelPolicies = translate('errors.missing_cancel_policies');
        }

        return errors;
    };

    return (
        <Form
            onSubmit={handleSubmit}
            mutators={{ ...arrayMutators }}
            validate={validateForm}
            initialValues={stepData[STEP_KEYS.STEP_5]}
            render={({ handleSubmit, form, values }) => {
                return (
                    <form onSubmit={handleSubmit} noValidate style={{ width: '100%', maxWidth: '480px' }}>
                        <Box component="section">
                            <Title title={translate('policies.title')} description={translate('policies.description')} />

                            {/* Form */}
                            <Grid2 container width="100%" direction="column" justifyContent="flex-start" alignItems="flex-start" gap="8px" mt="24px">
                                <PoliciesFormFields form={form} submitted={submitted} />
                            </Grid2>

                            <ActionButtons
                                handleSubmit={(e) => {
                                    setSubmitted(true);
                                    return handleSubmit(e);
                                }}
                                handleBack={handleBack}
                            />
                        </Box>
                    </form>
                );
            }}
        />
    );
};

export default PoliciesForm;
